import React from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";

import SliderOne from "../slider/SliderOne";
import ServiceTwo from "../../elements/service/ServiceTwo";
import About from "../HomeLayout/homeOne/About";
import Helmet from "./Helmet";

const App = () => {
    return (
        <div className="active-dark">
            <Helmet pageTitle="Home"/>
            <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png"/>

            <div className="slider-wrapper">
                <SliderOne/>
            </div>

            <div className="about-area about-position-top pb--120 bg_color--1">
                <About/>
            </div>

            <div className="service-area ptb--80  bg_image bg_image--3">
                <div className="container">
                    <ServiceTwo/>
                </div>
            </div>


            <Footer/>

        </div>
    )
}

export default App;
